import type { RequestMethod } from '@/types/stock';

export function requestMethodAfterAnalysisToggle(
  analysisOn: boolean,
  requestMethod: RequestMethod | null
): RequestMethod | null {
  if (!analysisOn) return null;
  return requestMethod;
}
